<template>
  <div class="basic_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('moneybag.myWallet') }}
      </div>
      <div
        class="top_right"
        @click="$router.push('/moneybag')"
      >
        <van-icon
          name="filter-o"
          size="25"
        />
      </div>
    </div>
    <!-- <div class="user_yw">
			<div class="all">
                <p >{{$t('trading.balance')}}</p>
			    <p >{{ utils_moneyMark() }}{{ funds }}</p>
            </div>
		</div>
		<div class="user_zrzc">
			<span class="rechargebtn" @click="$router.push('/invest')">{{$t('moneybag.recharge')}}</span>
			<span class="withdrawbtn" @click="$router.push('/cash')">{{$t('moneybag.withdraw')}}</span>
		</div> -->
		
    <!-- <div class="user_money">
			<div class="money_num">
				
				<div>
					<img src="../images/user/recharge1.png" alt="">
					<p style="font-weight: bold; font-size: 17px; margin: 0px 5px;">
						{{funds}} 
					</p>
					<span>{{ utils_moneyMark() }}</span>
				</div>
				<div style="font-size: 1.3em;font-weight: bold;">{{$t('invest.availableBalance')}}</div>
			</div>
			<div class="user_but">
				<div class="but_click but1" @click="$router.push('/cash')">
				{{$t('user.withdraw')}}
				</div>
				<div class="but_click but2" @click="$router.push('/invest')">
				{{$t('moneybag.recharge')}}
				</div>
			</div>
		</div> -->
    <van-empty
      v-if="listShow"
      :description="$t('moneybag.detailsEmpty')"
    />
		
    <div
      v-if="data"
      class="detail_box"
    >
      <div
        v-for="item in data"
        :key="item.id || item.time"
        class="detail_list"
      >
        <div>
          <p>{{ $t('shopds.money') }}</p>
          <p style="color: rgb(255, 83, 83);font-size: 20px;font-weight: bold;">
            $ {{ item.money }}
          </p>
        </div>
        <div>
          <p>
            {{ $t('shopds.time') }}
          </p>
          <p style="font-weight: bold;">
            {{ item.time }}
          </p>
        </div>
        <p
          v-if="item.status==0"
          style="text-align: right;font-weight: bold;"
        >
          {{ $t('shopds.cashstating') }}
        </p>
        <p
          v-if="item.status==1"
          style="text-align: right;font-weight: bold;"
        >
          {{ $t('shopds.cashstat') }}
        </p>
        <p
          v-if="item.status==2"
          style="text-align: right;font-weight: bold;"
        >
          {{ $t('shopds.cashstatfail') }}
        </p>
        <p v-if="item.status==2">
          {{ item.memo }}
        </p>	
      </div>
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
        DropdownMenu,
        DropdownItem,
		Icon
    } from 'vant';

    import { Empty } from 'vant';

    Vue.use(Empty);
    Vue.use(DropdownMenu).use(DropdownItem).use(Icon);

    export default {
        name: "Moneybag",
        data() {
            return {
				lang:this.$i18n.locale||"zh_cn",
                data: null,
				listShow:false
            };
        },
        created() {
			this.$parent.footer('user');
        },
        mounted() {
            Fetch('/user/cash_search').then(r => {
				this.showError(r.data.length);
                this.data = r.data;
				// if(this.data.length>0){
				// 	for (let i = 0; i < this.data.length; i++) {
				// 		this.data[i].time = new Date(this.data[i].time).getTime()/1000;
				// 	}
				// }
            })
        },
        methods: {
			showError(len){
			    len == 0 ? this.listShow = true : this.listShow = false
			}
        }
    };
</script>

<style lang="less" scoped>
    .red_top_bg {
		height: 44px;
    }
	.user_yw{
		text-align: center;
		width: 96%;
		margin-top: 20px;
		background: #D20100cc;
		margin-left: 2%;
		border-radius: 5px 5px 0 0;
		padding: 20px 0;
        display: flex;
		color: #FFF;
        div{
            width: 100%;
        }
		p:nth-child(1){
			font-size: 14px;
			margin-bottom: 20px;
		}
		p:nth-child(2){
			font-size: 14px;
			font-weight: bold;
		}
	}
	.user_zrzc{
		text-align: center;
		width: 96%;
		background: #D20100cc;
		margin-left: 2%;
		border-radius: 0 0 5px 5px;
		padding: 15px 0;
		display: flex;
		justify-content: space-between;
		text-align: center;
		span{
			width: 40%;
			color: #FFFFFF;
			margin: 0px 20px;
			padding: 12px 10px;
			border-radius: 5px;
			font-size: 14px;
		}
	}

    .detail_box {
        width: 96%;
        background: rgba(255, 255, 255, 1);
        border-radius: 6px;
        .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 8px;
            border-bottom: 1px solid #ECECEC;

            .de_wrap {
                flex: 2;

                .tit {
                    font-size: 12px;
                    color: rgba(0,0,0,.8);
                    line-height: 20px;
                    font-weight: bold;
                }

                .time {
                    font-size: 12px;
                    color: rgba(0,0,0,.8);
                    line-height: 17px;
                    margin-top: 10px;
                }
            }

            .price {
                flex: 1;
                font-size: 14px;
                line-height: 28px;
                font-weight: bold;
                text-align: right;
                color: #f12211;
                white-space: nowrap;
                &.del {
                    color: #3FAF3E;
                }
            }
        }
    }
	.user_money{
		display: block;
		width: 96%;
		margin-left: 2%;
	    background-color: #fff;
	    border-radius: 10px;
	    padding: 15px;
	    margin-top: 2vh;
	    background: url(../images/user/smallBackground.png) no-repeat;
	    background-size: cover;
	    background-position: 50%;
		.money_num{
		    width: auto;
		    height: 40px;
		    display: flex;
		    align-items: center;
		    justify-content: space-between;
		    font-size: 12px;
		    margin-bottom: 4%;
			>div:first-child {
			    display: flex;
			    align-items: center;
				img{
				    width: 20px;
				    height: 20px;
					display: inline-block;
					overflow: hidden;
					position: relative;
				}
				p{
					font-weight: bold;
					color: #000000e6;
					font-size: 17px;
					margin: 0px 5px;
				}
			}
		}
		.user_but{
		    display: flex;
		    justify-content: space-around;
		    align-items: center;
			.but_click{
			    width: 45%;
			    height: 40px;
			    border-radius: 10px;
			    display: flex;
			    align-items: center;
			    justify-content: center;
			}
		}
	}
	.detail_box,.basic_wrap{
	    width: 100%;
	    background: url('../images/shop2/2.png') no-repeat top;
		padding-bottom: 60px;
		.detail_list{
		    width: 90%;
		    height: 156px;
		    margin: 3% 5%;
		    background: url(../images/shop2/detailBackimg.png) no-repeat;
		    background-position: 50%;
		    background-size: cover;
		    border-radius: 20px;
		    padding: 25px;
		    display: flex;
		    flex-direction: column;
			line-height: 20px;
		    justify-content: space-around;
			>div:first-child {
			    width: 100%;
			    display: flex;
			    justify-content: space-between;
			    align-items: center;
			}
			>p:nth-child(2) {
			    font-size: 20px;
			    font-weight: 700;
			}
			>div:last-child p:last-child {
			    margin: 2% 0;
			    font-size: 12px;
			}
		}
		
	}

	/* Wallet records follow the user centre's softer card hierarchy. */
	.basic_wrap {
		min-height: 100vh;
		padding-bottom: 2.2rem;
		box-sizing: border-box;
		background: url('../images/shop2/2.png') no-repeat top;
	}

	.red_top_bg {
		height: 50px;
		border-bottom: 1px solid rgba(235, 235, 235, .82);
		background: rgba(255, 255, 255, .86);
		color: #222;
		backdrop-filter: blur(10px);
	}

	.big_tit {
		top: 13px;
		color: #222;
		font-size: 16px;
		font-weight: 700;
	}

	.top_right {
		top: 12px;
		right: 14px;
		color: #484848;
	}

	.detail_box {
		width: 100%;
		padding: 14px 12px 0;
		margin: 0;
		border-radius: 0;
		background: transparent;
		box-sizing: border-box;
	}

	.detail_box .detail_list {
		width: 100%;
		height: auto;
		min-height: 148px;
		padding: 16px;
		margin: 0 0 12px;
		border: 1px solid #ebebeb;
		border-radius: 18px;
		background: rgba(255, 255, 255, .96);
		box-shadow: none;
		box-sizing: border-box;
		line-height: 21px;
	}

	.detail_box .detail_list > div:first-child {
		padding-bottom: 12px;
		border-bottom: 1px solid #f0f0f0;
	}

	.detail_box .detail_list > div p {
		color: #717171;
		font-size: 12px;
	}

	.detail_box .detail_list > div:first-child p:last-child {
		color: #e31c5f !important;
		font-size: 21px !important;
		font-weight: 700;
	}

	.detail_box .detail_list > div:nth-child(2) {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-top: 10px;
	}

	.detail_box .detail_list > div:nth-child(2) p:last-child {
		color: #222;
		font-weight: 600 !important;
	}

	.detail_box .detail_list > p {
		margin: 8px 0 0;
		color: #e31c5f;
		font-size: 12px;
	}

	/deep/ .van-empty {
		margin: 14px 12px;
		border: 1px solid #ebebeb;
		border-radius: 18px;
		background: rgba(255, 255, 255, .92);
	}
	
</style>
